import React from 'react';

import MainPage from '../pages/main';
import SearchPage from '../pages/search';
import ArticlePage from '../pages/article';
import { ROUTES } from '../config/constants';

export const ROUTES_DEFAULT_ARRAY = [
  {
    path: ROUTES.HOME,
    element: <MainPage />,
  },
  {
    path: ROUTES.SEARCH,
    element: <SearchPage />,
  },
  {
    path: ROUTES.CATEGORY,
    element: <SearchPage />,
  },
  {
    path: ROUTES.ARTICLE,
    element: <ArticlePage />,
  },
];
